<template>
  <div id="promotion" v-if="config.gocheckin_feature == 1">
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/after-login">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Promotion</span>
            </li>
        </ul>
    </div>
    <vs-tabs :color="colorx" style="background: #fff">
      <vs-tab @click="colorx = 'primary'" label="Promotion list">
        <div class="con-tab-ejemplo p-6">
          <vs-promotion-list></vs-promotion-list>
        </div>
      </vs-tab>

      <vs-tab @click="colorx = 'primary'" label="Expired promotion list">
        <div class="con-tab-ejemplo p-6">
          <vs-promotion-list-expired></vs-promotion-list-expired>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
  <div v-else-if="config.gocheckin_feature == 0">
    <vx-card><h2>This is for Go Check In full version, please contact us for more info at <b>832-968-6668</b></h2></vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
export default {
  // props: {
  //   dataChange: {
  //     type: Object
  //   }
  // },
  data() {
    return {
      colorx: 'primary',
      items: [
        {
          title: 'Home',
          url: '/',
          icon: "HomeIcon",
        },
        {
          title: 'Promotion',
          active: true,
        },
      ],
      isOpenLoading: false
    };

  },
  // watch: {
  //   config: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       if(this.config && this.config.gocheckin_feature != 0 && this.config.gocheckin_feature != 1) {
  //         this.openLoadingInDiv();
  //       } else {
  //         this.closeLoading();
  //       }
  //     }
  //   },
  // },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
  },
  computed:{
    config() {
      return this.$store.getters["auth/config"];
    }
  }
};
</script>